import { render, staticRenderFns } from "./SubcontractorForm.vue?vue&type=template&id=b5636086&scoped=true"
import script from "./SubcontractorForm.vue?vue&type=script&lang=js"
export * from "./SubcontractorForm.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorForm.vue?vue&type=style&index=0&id=b5636086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5636086",
  null
  
)

export default component.exports